import { useEffect } from "react";
const DEFAULT_OPTIONS = {
    delay: 200
};
const useOnScreenVariation = (callback, options = DEFAULT_OPTIONS)=>{
    useEffect(()=>{
        let isScrolling;
        const scrollListener = ()=>{
            clearTimeout(isScrolling);
            isScrolling = setTimeout(()=>{
                callback();
            }, options.delay ?? DEFAULT_OPTIONS.delay);
        };
        if (options.runAtStart) scrollListener();
        window.addEventListener('scroll', scrollListener);
        window.addEventListener('resize', scrollListener);
        return ()=>{
            window.removeEventListener('scroll', scrollListener);
            window.removeEventListener('resize', scrollListener);
        };
    }, [
        callback,
        options.delay,
        options.runAtStart
    ]);
};
export { useOnScreenVariation };
